import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, BookOpenIcon, HeadphonesIcon, BrainIcon, ZapIcon } from 'lucide-react';
export function LibrarySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-surface)'
  }} data-id="element-189">
      <div className="max-w-2xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-191">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-192">
            Bienvenido
          </p>
          <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-193">
            Crecimiento AudioPro
          </h2>
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-194">
            Una biblioteca digital construida para personas que:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="space-y-4 mb-16" data-id="element-195">
          <div className="flex items-start gap-4" data-id="element-196">
            <CheckIcon className="w-5 h-5 mt-1 flex-shrink-0" style={{
            color: 'var(--color-accent)'
          }} data-id="element-197" />
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-198">
              Quieren crecer espiritualmente{' '}
              <span style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-199">
                sin volverse místicas desconectadas de la realidad
              </span>
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-200">
            <CheckIcon className="w-5 h-5 mt-1 flex-shrink-0" style={{
            color: 'var(--color-accent)'
          }} data-id="element-201" />
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-202">
              Quieren prosperar financieramente{' '}
              <span style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-203">
                sin traicionar sus valores más profundos
              </span>
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-204">
            <CheckIcon className="w-5 h-5 mt-1 flex-shrink-0" style={{
            color: 'var(--color-accent)'
          }} data-id="element-205" />
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-206">
              Quieren disciplina y claridad{' '}
              <span style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-207">
                sin depender de rachas de motivación
              </span>
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-208">
            <CheckIcon className="w-5 h-5 mt-1 flex-shrink-0" style={{
            color: 'var(--color-accent)'
          }} data-id="element-209" />
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-210">
              Entienden que el dinero amplifica lo que ya eres —{' '}
              <span style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-211">
                y quieren ser algo que vale la pena amplificar
              </span>
            </p>
          </div>
        </motion.div>

        {/* What's inside */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.5,
        duration: 0.7
      }} data-id="element-212">
          <h3 className="text-2xl font-black mb-8 text-center" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-213">
            ¿Qué Encuentras Dentro?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-214">
            <div className="p-6 rounded-sm" style={{
            background: '#0f0f0f',
            border: '1px solid var(--color-border)'
          }} data-id="element-215">
              <div className="flex items-center gap-3 mb-3" data-id="element-216">
                <BookOpenIcon className="w-5 h-5" style={{
                color: 'var(--color-accent)'
              }} data-id="element-217" />
                <p className="font-bold" style={{
                color: 'var(--color-text)'
              }} data-id="element-218">
                  Libros Digitales
                </p>
              </div>
              <p className="text-sm leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-219">
                Marcos mentales prácticos. Lectura enfocada, lenguaje directo,
                aplicación inmediata.
              </p>
            </div>

            <div className="p-6 rounded-sm" style={{
            background: '#0f0f0f',
            border: '1px solid var(--color-border)'
          }} data-id="element-220">
              <div className="flex items-center gap-3 mb-3" data-id="element-221">
                <HeadphonesIcon className="w-5 h-5" style={{
                color: 'var(--color-accent)'
              }} data-id="element-222" />
                <p className="font-bold" style={{
                color: 'var(--color-text)'
              }} data-id="element-223">
                  Audiolibros Estratégicos
                </p>
              </div>
              <p className="text-sm leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-224">
                Reprogramación pasiva. Funcionan mientras tu mente consciente
                está en otro lugar.
              </p>
            </div>

            <div className="p-6 rounded-sm" style={{
            background: '#0f0f0f',
            border: '1px solid var(--color-border)'
          }} data-id="element-225">
              <div className="flex items-center gap-3 mb-3" data-id="element-226">
                <BrainIcon className="w-5 h-5" style={{
                color: 'var(--color-accent)'
              }} data-id="element-227" />
                <p className="font-bold" style={{
                color: 'var(--color-text)'
              }} data-id="element-228">
                  Meditaciones Guiadas
                </p>
              </div>
              <p className="text-sm leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-229">
                No genéricas. Diseñadas para desinstalar creencias específicas
                de escasez, miedo y bloqueo.
              </p>
            </div>

            <div className="p-6 rounded-sm" style={{
            background: '#0f0f0f',
            border: '1px solid var(--color-border)'
          }} data-id="element-230">
              <div className="flex items-center gap-3 mb-3" data-id="element-231">
                <ZapIcon className="w-5 h-5" style={{
                color: 'var(--color-accent)'
              }} data-id="element-232" />
                <p className="font-bold" style={{
                color: 'var(--color-text)'
              }} data-id="element-233">
                  Protocolos Mentales
                </p>
              </div>
              <p className="text-sm leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-234">
                Sistemas de 5–20 minutos. Claridad, enfoque, expansión
                financiera. Sin excusas de tiempo.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}